import comp from "./SharedWithList.js";
export default comp;
